import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface Facility {
  id: number;
  name: string;
  type: 'Hospital' | 'Diagnostic Center';
  location: string;
  minCost: number;
  maxCost: number | null;
  category: 'Affordable' | 'Mid-Range' | 'Premium';
  rating: number;
  waitTime: number;
  lat: number;
  lng: number;
  phone: string;
  services: string;
}

const facilities: Facility[] = [
  // 21 Hospitals
  {
    id: 1,
    name: 'Jehangir Hospital',
    type: 'Hospital',
    location: 'Jehangir Hospital, 32, Sasoon Rd, opposite Railway Station, Central Excise Colony, Sangamvadi, Pune, Maharashtra 411001',
    minCost: 50000,
    maxCost: 200000,
    services: 'Gynecology, Neurology, Cardiac, Renal',
    category: 'Premium',
    rating: 4.8,
    waitTime: 30,
    lat: 18.5314,
    lng: 73.8803,
    phone: '02066819966'
  },
  {
    id: 2,
    name: 'Gupte Hospital',
    type: 'Hospital',
    location: 'Bhandarkar Road, Pune',
    minCost: 30000,
    maxCost: 150000,
    services: 'Pregnancy Care, Neonatal Care, Fertility',
    category: 'Mid-Range',
    rating: 4.6,
    waitTime: 20,
    lat: 18.5204,
    lng: 73.8567,
    phone: '093713 07592'
  },
  {
    id: 3,
    name: 'Deenanath Mangeshkar Hospital',
    type: 'Hospital',
    location: 'Erandwane, Pune',
    minCost: 70000,
    maxCost: 300000,
    services: 'Multispecialty, Neonatal, Gynecology',
    category: 'Premium',
    rating: 4.9,
    waitTime: 40,
    lat: 18.5074,
    lng: 73.8077,
    phone: '020 4015 1000'
  },
  {
    id: 4,
    name: 'Yashwantrao Chavan Memorial Hospital',
    type: 'Hospital',
    location: 'Pimpri, Pune',
    minCost: 15000,
    maxCost: 80000,
    services: 'Obstetrics, Gynecology, Pediatrics',
    category: 'Affordable',
    rating: 4.2,
    waitTime: 45,
    lat: 18.6298,
    lng: 73.7997,
    phone: '020 6733 2222'
  },
  {
    id: 5,
    name: 'Kamala Nehru Hospital',
    type: 'Hospital',
    location: 'Mangalwar Peth Rd, near Kasba Post Office, Gandhinagar, Mangalwar Peth, Kasba Peth, Pune, Maharashtra 411011',
    minCost: 10000,
    maxCost: 60000,
    services: 'Maternity, Child Health, Emergency',
    category: 'Affordable',
    rating: 4.1,
    waitTime: 30,
    lat: 18.5124,
    lng: 73.8632,
    phone: '087899 44965'
  },
  {
    id: 6,
    name: 'Cloudnine Hospital',
    type: 'Hospital',
    location: 'SB Road, Pune',
    minCost: 60000,
    maxCost: 200000,
    services: 'Maternity, Neonatology, Fertility',
    category: 'Premium',
    rating: 4.8,
    waitTime: 25,
    lat: 18.5362,
    lng: 73.8264,
    phone: '99729-99729'
  },
  {
    id: 7,
    name: 'Motherhood Hospital',
    type: 'Hospital',
    location: 'Kharadi, Pune',
    minCost: 40000,
    maxCost: 180000,
    services: 'Maternity, Neonatology, Fertility',
    category: 'Premium',
    rating: 4.7,
    waitTime: 20,
    lat: 18.5515,
    lng: 73.9474,
    phone: '08494800097'
  },
  {
    id: 8,
    name: 'Ruby Hall Clinic',
    type: 'Hospital',
    location: 'Sassoon Road, Pune',
    minCost: 70000,
    maxCost: 350000,
    services: 'Neonatology, Obstetrics, Multispecialty',
    category: 'Premium',
    rating: 4.9,
    waitTime: 35,
    lat: 18.5204,
    lng: 73.8567,
    phone: '02066455100'
  },
  {
    id: 9,
    name: 'Aditya Birla Memorial Hospital',
    type: 'Hospital',
    location: 'Chinchwad, Pune',
    minCost: 80000,
    maxCost: 300000,
    services: 'Multispecialty, Neonatal, Maternity',
    category: 'Premium',
    rating: 4.9,
    waitTime: 40,
    lat: 18.6298,
    lng: 73.8089,
    phone: '09881123006'
  },
  {
    id: 10,
    name: 'Sahyadri Hospitals',
    type: 'Hospital',
    location: 'Multiple Locations, Pune',
    minCost: 60000,
    maxCost: 200000,
    services: 'Multispecialty, Neonatal, Maternity',
    category: 'Mid-Range',
    rating: 4.6,
    waitTime: 30,
    lat: 18.5679,
    lng: 73.9143,
    phone: '08888822222'
  },
  {
    id: 11,
    name: 'Cradle Maternity and Women Care',
    type: 'Hospital',
    location: 'Pimple Nilakh, Pimpri-Chinchwad',
    minCost: 50000,
    maxCost: 200000,
    services: 'Maternity, Obstetrics, Fertility Treatments',
    category: 'Premium',
    rating: 4.6,
    waitTime: 30,
    lat: 18.5892,
    lng: 73.7797,
    phone: '08087688788'
  },
  {
    id: 12,
    name: 'Ankura Hospital for Women & Children',
    type: 'Hospital',
    location: 'Aundh, Pune',
    minCost: 70000,
    maxCost: 250000,
    services: 'Neonatology, Pediatrics, Obstetrics',
    category: 'Premium',
    rating: 4.8,
    waitTime: 30,
    lat: 18.5642,
    lng: 73.8077,
    phone: '09053108108'
  },
  {
    id: 13,
    name: 'Dugad Hospital',
    type: 'Hospital',
    location: 'Maharshi Nagar, Pune',
    minCost: 30000,
    maxCost: 120000,
    services: 'Maternity, General Medicine',
    category: 'Mid-Range',
    rating: 4.3,
    waitTime: 25,
    lat: 18.5314,
    lng: 73.8567,
    phone: '08928605525'
  },
  {
    id: 14,
    name: 'Bharati Hospital',
    type: 'Hospital',
    location: 'Katraj, Pune',
    minCost: 30000,
    maxCost: 150000,
    services: 'Obstetrics, Pediatrics, General Medicine',
    category: 'Affordable',
    rating: 4.4,
    waitTime: 30,
    lat: 18.4574,
    lng: 73.8567,
    phone: '02040555555'
  },
  {
    id: 15,
    name: 'Noble Hospital',
    type: 'Hospital',
    location: 'Hadapsar, Pune',
    minCost: 50000,
    maxCost: 250000,
    services: 'Neonatology, Obstetrics, Gynecology',
    category: 'Premium',
    rating: 4.7,
    waitTime: 25,
    lat: 18.5089,
    lng: 73.9260,
    phone: '8007006611'
  },
  {
    id: 16,
    name: 'Lotus Multispeciality Hospital',
    type: 'Hospital',
    location: 'Nigdi, Pune',
    minCost: 40000,
    maxCost: 200000,
    services: 'Pediatrics, Obstetrics, Emergency Services',
    category: 'Mid-Range',
    rating: 4.5,
    waitTime: 30,
    lat: 18.6586,
    lng: 73.7697,
    phone: '08411811558'
  },
  {
    id: 17,
    name: 'KEM Hospital',
    type: 'Hospital',
    location: 'Rasta Peth, Pune',
    minCost: 20000,
    maxCost: 100000,
    services: 'Multispecialty, Pediatrics, Obstetrics',
    category: 'Affordable',
    rating: 4.6,
    waitTime: 45,
    lat: 18.5314,
    lng: 73.8567,
    phone: '02066037300'
  },
  {
    id: 18,
    name: 'Poona Hospital & Research Centre',
    type: 'Hospital',
    location: 'Shivaji Nagar, Pune',
    minCost: 50000,
    maxCost: 200000,
    services: 'Multispecialty, Maternity, Pediatrics',
    category: 'Premium',
    rating: 4.8,
    waitTime: 35,
    lat: 18.5314,
    lng: 73.8467,
    phone: '09730559600'
  },
  {
    id: 19,
    name: 'Ranka Hospital',
    type: 'Hospital',
    location: 'Camp, Pune',
    minCost: 40000,
    maxCost: 150000,
    services: 'Obstetrics, Pediatrics, Gynecology',
    category: 'Mid-Range',
    rating: 4.5,
    waitTime: 30,
    lat: 18.5204,
    lng: 73.8767,
    phone: '7387601495'
  },
  {
    id: 20,
    name: 'Mother Teresa Charitable Trust Hospital',
    type: 'Hospital',
    location: 'Yerawada, Pune',
    minCost: 20000,
    maxCost: 80000,
    services: 'Maternity, Pediatrics, General Medicine',
    category: 'Affordable',
    rating: 4.7,
    waitTime: 30,
    lat: 18.5514,
    lng: 73.8867,
    phone: '08494800097'
  },
  {
    id: 21,
    name: 'Niramaya Hospital',
    type: 'Hospital',
    location: 'Bavdhan, Pune',
    minCost: 40000,
    maxCost: 180000,
    services: 'Maternity, Pediatrics, Neonatology',
    category: 'Mid-Range',
    rating: 4.6,
    waitTime: 25,
    lat: 18.5074,
    lng: 73.7697,
    phone: '08421466632'
  },
  // 11 Diagnostic Centers
  {
    id: 23,
    name: 'Gupte Hospital Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Bhandarkar Road, Pune',
    minCost: 1800,
    maxCost: 3200,
    services: 'Specialized in gynecology and diagnostics',
    category: 'Mid-Range',
    rating: 4.6,
    waitTime: 25,
    lat: 18.5204,
    lng: 73.8567,
    phone: '09371307592'
  },
  {
    id: 24,
    name: 'Deenanath Mangeshkar Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Erandwane, Pune',
    minCost: 2500,
    maxCost: 4000,
    services: 'Advanced diagnostic and research capabilities',
    category: 'Premium',
    rating: 4.9,
    waitTime: 35,
    lat: 18.5074,
    lng: 73.8077,
    phone: '02040151000'
  },
  {
    id: 25,
    name: 'AIMS Hospital Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Aundh, Pune',
    minCost: 800,
    maxCost: null,
    services: 'Affordable diagnostic services',
    category: 'Affordable',
    rating: 4.3,
    waitTime: 20,
    lat: 18.5642,
    lng: 73.8177,
    phone: '08975044444'
  },
  {
    id: 26,
    name: 'Ranka Hospital Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Camp, Pune',
    minCost: 1500,
    maxCost: 3500,
    services: 'Comprehensive healthcare services',
    category: 'Mid-Range',
    rating: 4.5,
    waitTime: 30,
    lat: 18.5204,
    lng: 73.8767,
    phone: '02024261600'
  },
  {
    id: 27,
    name: 'Redcliffe Labs',
    type: 'Diagnostic Center',
    location: 'Multiple locations in Pune',
    minCost: 3000,
    maxCost: null,
    services: 'Home sample collection available',
    category: 'Premium',
    rating: 4.7,
    waitTime: 15,
    lat: 18.5204,
    lng: 73.8567,
    phone: '08988988787'
  },
  {
    id: 28,
    name: 'Apollo Diagnostics',
    type: 'Diagnostic Center',
    location: 'Multiple centers in Pune',
    minCost: 3500,
    maxCost: null,
    services: 'TORCH 10 profile (IgG and IgM)',
    category: 'Premium',
    rating: 4.8,
    waitTime: 20,
    lat: 18.5314,
    lng: 73.8467,
    phone: '09767623098'
  },
  {
    id: 29,
    name: 'Nidan Diagnostic Services',
    type: 'Diagnostic Center',
    location: 'Wakad, Pimpri Chinchwad, Pune',
    minCost: 2500,
    maxCost: null,
    services: 'Modern diagnostic facilities',
    category: 'Mid-Range',
    rating: 4.5,
    waitTime: 18,
    lat: 18.6086,
    lng: 73.7597,
    phone: '09082528512'
  },
  {
    id: 30,
    name: 'Lifeberries Health',
    type: 'Diagnostic Center',
    location: 'Pune',
    minCost: 4000,
    maxCost: 5500,
    services: 'Comprehensive diagnostic services',
    category: 'Premium',
    rating: 4.9,
    waitTime: 25,
    lat: 18.5204,
    lng: 73.8567,
    phone: '09028151133'
  },
  {
    id: 31,
    name: 'NM Medical',
    type: 'Diagnostic Center',
    location: 'Kalyani Nagar, Pune',
    minCost: 1300,
    maxCost: null,
    services: 'Advanced imaging and diagnostic services',
    category: 'Affordable',
    rating: 4.4,
    waitTime: 15,
    lat: 18.5514,
    lng: 73.9067,
    phone: '08408861501'
  },
  {
    id: 32,
    name: 'PH Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Opposite Hotel Panchami, Satara Road, Pune',
    minCost: 2000,
    maxCost: 3800,
    services: 'State-of-the-art diagnostic facilities',
    category: 'Mid-Range',
    rating: 4.6,
    waitTime: 20,
    lat: 18.4874,
    lng: 73.8567,
    phone: '09240222222'
  },
  {
    id: 33,
    name: 'Parvati Diagnostic Center',
    type: 'Diagnostic Center',
    location: 'Pune',
    minCost: 1250,
    maxCost: null,
    services: 'Precise and affordable diagnostic services',
    category: 'Affordable',
    rating: 4.3,
    waitTime: 18,
    lat: 18.4974,
    lng: 73.8567,
    phone: '02025882905'
  }
];

export default function MapView() {
  const [selectedCategory, setSelectedCategory] = useState<string>('All');
  const [selectedType, setSelectedType] = useState<string>('All');
  const [selectedFacility, setSelectedFacility] = useState<Facility | null>(null);
  const [userLocation, setUserLocation] = useState<string>('');

  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: filtersRef, isVisible: filtersVisible } = useScrollAnimation();
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation();

  const filteredFacilities = facilities.filter((facility) => {
    const matchesCategory = selectedCategory === 'All' || facility.category === selectedCategory;
    const matchesType = selectedType === 'All' || facility.type === selectedType;
    return matchesCategory && matchesType;
  });

  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'Affordable':
        return 'bg-emerald-100 text-emerald-700 border-emerald-300';
      case 'Mid-Range':
        return 'bg-amber-100 text-amber-700 border-amber-300';
      case 'Premium':
        return 'bg-purple-100 text-purple-700 border-purple-300';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-300';
    }
  };

  const getDirections = (facility: Facility) => {
    // Use exact Google Maps link for Kamala Nehru Hospital
    if (facility.id === 5) {
      window.open('https://maps.app.goo.gl/gZf4XHmHCHNTzq2z9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Jehangir Hospital
    if (facility.id === 1) {
      window.open('https://maps.app.goo.gl/w6beunUQpe5etfk88', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Gupte Hospital
    if (facility.id === 2) {
      window.open('https://maps.app.goo.gl/T7tdyM1bhXCE7KcZ9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Deenanath Mangeshkar Hospital
    if (facility.id === 3) {
      window.open('https://maps.app.goo.gl/nV5JFdgkuuVeN1Kd7', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Yashwantrao Chavan Memorial Hospital
    if (facility.id === 4) {
      window.open('https://maps.app.goo.gl/LvuDCqUo25EpvFmf6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Cloudnine Hospital
    if (facility.id === 6) {
      window.open('https://maps.app.goo.gl/K8tSXTH2GACgCTNV6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Motherhood Hospital
    if (facility.id === 7) {
      window.open('https://maps.app.goo.gl/6BXYc7mRRhPr8ziZ6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Ruby Hall Clinic
    if (facility.id === 8) {
      window.open('https://maps.app.goo.gl/8VZhinM1SHE5yvPeA', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Aditya Birla Memorial Hospital
    if (facility.id === 9) {
      window.open('https://maps.app.goo.gl/Y8L4urhUoLtsjxDU8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Sahyadri Hospitals
    if (facility.id === 10) {
      window.open('https://maps.app.goo.gl/ZEZgHMYtVVEmP4Gs9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Cradle Maternity and Women Care
    if (facility.id === 11) {
      window.open('https://maps.app.goo.gl/GkvMMQPWs9xkcM1SA', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Ankura Hospital for Women & Children
    if (facility.id === 12) {
      window.open('https://maps.app.goo.gl/WjgodYHwQuTo8V6h9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Dugad Hospital
    if (facility.id === 13) {
      window.open('https://maps.app.goo.gl/hD5sUx3Ua31iKTpB9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Bharati Hospital
    if (facility.id === 14) {
      window.open('https://maps.app.goo.gl/d6kLGeEvH8Sw6UFfA', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Noble Hospital
    if (facility.id === 15) {
      window.open('https://maps.app.goo.gl/GGymzCywM8QautFh6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Lotus Multispeciality Hospital
    if (facility.id === 16) {
      window.open('https://maps.app.goo.gl/SVCo2Cdia6irqCz97', '_blank');
      return;
    }
    
    // Use exact Google Maps link for KEM Hospital
    if (facility.id === 17) {
      window.open('https://maps.app.goo.gl/EyeLdg9heJDq5iBV8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Poona Hospital & Research Centre
    if (facility.id === 18) {
      window.open('https://maps.app.goo.gl/Z9eHbSXCRCBWjqSi9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Ranka Hospital
    if (facility.id === 19) {
      window.open('https://maps.app.goo.gl/ia9gnpKz2S48gHTB7', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Mother Teresa Charitable Trust Hospital
    if (facility.id === 20) {
      window.open('https://maps.app.goo.gl/XeL177hDXKLUvuqV9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Niramaya Hospital
    if (facility.id === 21) {
      window.open('https://maps.app.goo.gl/6hf6tpGJVDdR4aBa8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Gupte Hospital Diagnostic Center
    if (facility.id === 23) {
      window.open('https://maps.app.goo.gl/YY5x64H99hugiNpX8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Deenanath Mangeshkar Diagnostic Center
    if (facility.id === 24) {
      window.open('https://maps.app.goo.gl/9P5Fv2tPo31DZ4GQ8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for AIMS Hospital Diagnostic Center
    if (facility.id === 25) {
      window.open('https://maps.app.goo.gl/SH3515mU4eyD6JFe6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Ranka Hospital Diagnostic Center
    if (facility.id === 26) {
      window.open('https://maps.app.goo.gl/UCajPVS6NBBGVatq9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Redcliffe Labs
    if (facility.id === 27) {
      window.open('https://maps.app.goo.gl/6bMvZrFH17HHRDW98', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Apollo Diagnostics
    if (facility.id === 28) {
      window.open('https://maps.app.goo.gl/1sXtEcLNGYEySEnE8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Nidan Diagnostic Services
    if (facility.id === 29) {
      window.open('https://maps.app.goo.gl/LzdkeCQYk7XT1Kip9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Lifeberries Health
    if (facility.id === 30) {
      window.open('https://maps.app.goo.gl/TbuPD53WqKCi4NWv6', '_blank');
      return;
    }
    
    // Use exact Google Maps link for NM Medical
    if (facility.id === 31) {
      window.open('https://maps.app.goo.gl/pGLLzYFixmdLFXKP9', '_blank');
      return;
    }
    
    // Use exact Google Maps link for PH Diagnostic Center
    if (facility.id === 32) {
      window.open('https://maps.app.goo.gl/goaYF8VeCaeoYE6g8', '_blank');
      return;
    }
    
    // Use exact Google Maps link for Parvati Diagnostic Center
    if (facility.id === 33) {
      window.open('https://maps.app.goo.gl/8J4pZSkKwzqMjHz99', '_blank');
      return;
    }
    
    const destination = `${facility.lat},${facility.lng}`;
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${destination}`, '_blank');
  };

  const callFacility = (phone: string) => {
    window.open(`tel:${phone}`, '_self');
  };

  return (
    <section id="map-view" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div
          ref={headerRef}
          className={`text-center mb-12 ${headerVisible ? 'animate-fade-in-down' : 'opacity-0'}`}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 rounded-full mb-4">
            <i className="ri-map-pin-line text-blue-600"></i>
            <span className="text-sm font-semibold text-blue-700">Interactive Map</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Find Facilities Near You</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore all 33 healthcare facilities on an interactive map with directions and contact information
          </p>
        </div>

        {/* Filters */}
        <div
          ref={filtersRef}
          className={`mb-8 ${filtersVisible ? 'animate-fade-in-up animation-delay-200' : 'opacity-0'}`}
        >
          <div className="mb-8 flex flex-wrap gap-4 justify-center">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Filter by Type</label>
              <div className="flex gap-2">
                {['All', 'Hospital', 'Diagnostic Center'].map((type) => (
                  <button
                    key={type}
                    onClick={() => setSelectedType(type)}
                    className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap ${
                      selectedType === type
                        ? 'bg-blue-600 text-white shadow-lg'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-200'
                    }`}
                  >
                    {type}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Filter by Category</label>
              <div className="flex gap-2">
                {['All', 'Affordable', 'Mid-Range', 'Premium'].map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-4 py-2 rounded-lg font-medium text-sm transition-all whitespace-nowrap ${
                      selectedCategory === category
                        ? 'bg-blue-600 text-white shadow-lg'
                        : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-200'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Map Container */}
        <div
          ref={contentRef}
          className={`grid lg:grid-cols-3 gap-8 ${contentVisible ? 'animate-fade-in-up animation-delay-300' : 'opacity-0'}`}
        >
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="h-[600px] w-full">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d242118.18174815655!2d73.72288773359375!3d18.52461405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Pune Healthcare Facilities Map"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Facility List */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-3xl shadow-2xl p-6 max-h-[600px] overflow-y-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {filteredFacilities.length} Facilities Found
              </h3>
              
              <div className="space-y-4">
                {filteredFacilities.map((facility) => (
                  <div
                    key={facility.id}
                    className="p-4 border-2 border-gray-200 rounded-2xl hover:border-blue-500 hover:shadow-lg transition-all cursor-pointer"
                    onClick={() => setSelectedFacility(facility)}
                  >
                    <div className="flex items-start justify-between mb-2">
                      <h4 className="font-bold text-gray-900 text-base line-clamp-2 flex-1">
                        {facility.name}
                      </h4>
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold border ${getCategoryColor(facility.category)} ml-2 whitespace-nowrap`}>
                        {facility.category}
                      </span>
                    </div>

                    <div className="flex items-center gap-2 mb-2">
                      <div className="flex items-center gap-1">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={`ri-star-${i < Math.floor(facility.rating) ? 'fill' : 'line'} text-amber-400 text-xs`}
                          ></i>
                        ))}
                      </div>
                      <span className="text-sm font-semibold text-gray-700">{facility.rating}</span>
                    </div>

                    <p className="text-sm text-gray-600 mb-3 line-clamp-1">
                      <i className="ri-map-pin-line text-blue-600 mr-1"></i>
                      {facility.location}
                    </p>

                    <div className="flex gap-2">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          getDirections(facility);
                        }}
                        className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
                      >
                        <i className="ri-direction-line mr-1"></i>
                        Directions
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          callFacility(facility.phone);
                        }}
                        className="flex-1 px-3 py-2 border-2 border-blue-600 text-blue-600 rounded-lg text-sm font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap"
                      >
                        <i className="ri-phone-line mr-1"></i>
                        Call
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="mt-12 grid md:grid-cols-4 gap-6">
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-xl mx-auto mb-4">
              <i className="ri-map-pin-2-line text-3xl text-blue-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">5</div>
            <div className="text-sm text-gray-600">Areas Covered</div>
          </div>
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-xl mx-auto mb-4">
              <i className="ri-hospital-line text-3xl text-emerald-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">21</div>
            <div className="text-sm text-gray-600">Hospitals</div>
          </div>
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-xl mx-auto mb-4">
              <i className="ri-test-tube-line text-3xl text-amber-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">12</div>
            <div className="text-sm text-gray-600">Diagnostic Centers</div>
          </div>
          <div className="bg-white rounded-2xl p-6 text-center shadow-lg">
            <div className="w-14 h-14 flex items-center justify-center bg-purple-100 rounded-xl mx-auto mb-4">
              <i className="ri-route-line text-3xl text-purple-600"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-1">24/7</div>
            <div className="text-sm text-gray-600">Navigation</div>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {selectedFacility && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedFacility(null)}
        >
          <div 
            className="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-8">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-2">
                    {selectedFacility.name}
                  </h3>
                  <span className={`px-3 py-1 rounded-full text-sm font-semibold border ${getCategoryColor(selectedFacility.category)}`}>
                    {selectedFacility.category}
                  </span>
                </div>
                <button
                  onClick={() => setSelectedFacility(null)}
                  className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                >
                  <i className="ri-close-line text-xl text-gray-700"></i>
                </button>
              </div>

              <div className="space-y-6">
                <div className="p-4 bg-gray-50 rounded-xl">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-blue-600 text-2xl mt-1"></i>
                    <div>
                      <div className="text-sm font-semibold text-gray-900 mb-1">Location</div>
                      <p className="text-base text-gray-700">{selectedFacility.location}</p>
                    </div>
                  </div>
                </div>

                <div className="p-4 bg-blue-50 rounded-xl">
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-sm font-semibold text-gray-900 mb-1">Contact</div>
                      <p className="text-lg font-bold text-blue-700">{selectedFacility.phone}</p>
                    </div>
                    <button
                      onClick={() => callFacility(selectedFacility.phone)}
                      className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                    >
                      <i className="ri-phone-line text-xl text-white"></i>
                    </button>
                  </div>
                </div>

                <div className="p-4 bg-emerald-50 rounded-xl">
                  <div className="text-sm font-semibold text-gray-900 mb-2">Cost Range</div>
                  <p className="text-2xl font-bold text-emerald-700">
                    ₹{selectedFacility.minCost.toLocaleString()}
                    {selectedFacility.maxCost && ` - ₹${selectedFacility.maxCost.toLocaleString()}`}
                  </p>
                </div>

                <div className="p-4 bg-amber-50 rounded-xl">
                  <div className="text-sm font-semibold text-gray-900 mb-2">Services</div>
                  <p className="text-base text-gray-700">{selectedFacility.services}</p>
                </div>

                <button
                  onClick={() => getDirections(selectedFacility)}
                  className="w-full px-6 py-4 bg-blue-600 text-white rounded-xl font-semibold text-base hover:bg-blue-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-direction-line mr-2"></i>
                  Get Directions
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
